module.exports = __webpack_public_path__ + "static/img/组 2841.5b98c43.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/组 2841.png
// module id = npkd
// module chunks = 0